/* =============================================================
 * import
 * ========================================================== */
import {toggleClass, isMobile} from "../utils/utils";
import {gsap} from "gsap/gsap-core";
import {ScrollSmoother} from "gsap/ScrollSmoother";

let tl = null; // タイムラインのグローバル参照


/* =============================================================
 * menu
 * メニューに関する実行関数
 * ========================================================== */
export function menu() {

  const body = document.body;
  const openBtn = document.querySelectorAll('.js-menu-btn-open'); // 開くボタン
  const closeBtn = document.querySelectorAll('.js-menu-btn-close, .menu_content_inner a, .header_logo_link, .menu_nav_rules_item_link, .offer_bottom_link'); // 閉じるボタン

  // menu open
  if (openBtn) {
    openBtn.forEach(btn => {
      btn.addEventListener('click', () => {
        body.classList.add('menu-open');
        body.classList.remove('menu-close');
        menuOpenAnimation(); // CSSで管理する場合は不要
      });
    });
  }

  // menu close
  if (closeBtn) {
    closeBtn.forEach(btn => {
      btn.addEventListener('click', () => {
        if (document.body.classList.contains('menu-open')) {
          body.classList.remove('menu-open');
          body.classList.add('menu-close');
          menuCloseAnimation(); // CSSで管理する場合は不要
        }
      });
    });
  }

}


/* =============================================================
 * menuOpenAnimation
 * メニューを開くアニメーション
 * ========================================================== */
function menuOpenAnimation() {

  const openBtn = document.querySelector('#menu-open-btn');
  const closeBtn = document.querySelector('#menu-close-btn');

  const menu = document.querySelector('.menu_content');
  const menuBg = document.querySelector('.menu_bg');
  const mainLists = menu.querySelectorAll('.menu_nav_list_item, .menu_nav_rules_item, .menu_nav_btn_item');

  // 既にアニメーションが進行中の場合、それをキャンセルし、即時に最終状態へ
  if (tl) {
    tl.kill();
  }

  tl = gsap.timeline({
    repeat: 0,
    ease: "curtain",
  });

  // open animation
  gsap.set(menu, {
    autoAlpha: 1,
  });

  gsap.set(menuBg, {
    x: '100%',
    width: '100%',
  });


  tl
    // MENUボタンの非表示化アニメーション
    .fromTo(openBtn, {
      webkitClipPath: 'inset(0% 0% 0% 0%)',
      clipPath: 'inset(0% 0% 0% 0%)',
    }, {
      webkitClipPath: 'inset(0% 50% 0% 50%)',
      clipPath: 'inset(0% 50% 0% 50%)',
      duration: .6,
    }, "<")

    // MENU背景の表示アニメーション（上記と同じタイミング
    .to(menuBg, {
      x: '0%',
      width: '100%',
      autoAlpha: 1,
      duration: .5,
    }, "<")

    // MENUコンテンツの表示アニメーション（上記と同じタイミング
    .fromTo(menu, {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
    }, "<")

    .fromTo(mainLists, {
      x: '30%',
      autoAlpha: 0.5,
      webkitClipPath: 'inset(0% 0% 0% 100%)',
      clipPath: 'inset(0% 0% 0% 100%)',
    }, {
      x: '0%',
      autoAlpha: 1,
      webkitClipPath: 'inset(0% 0% 0% 0%)',
      clipPath: 'inset(0% 0% 0% 0%)',
      duration: .5,
      stagger: {
        each: .05,
      },
    }, "<")

    .call(toggleClass, [openBtn, 'ing'], ">")

    .add(function() {
      lockScroll(); // スクロールを止める
    }, "<")

    .fromTo(closeBtn, {
      webkitClipPath: 'inset(0% 50% 0% 50%)',
      clipPath: 'inset(0% 50% 0% 50%)',
    }, {
      webkitClipPath: 'inset(0% 0% 0% 0%)',
      clipPath: 'inset(0% 0% 0% 0%)',
      duration: .6,
    }, ">")
  ;
}


/* =============================================================
 * menuCloseAnimation
 * メニューを閉じるアニメーション
 * ========================================================== */
function menuCloseAnimation() {

  const openBtn = document.querySelector('#menu-open-btn');
  const closeBtn = document.querySelector('#menu-close-btn');

  const menu = document.querySelector('.menu_content');
  const menuBg = document.querySelector('.menu_bg');
  const mainLists = menu.querySelectorAll('.menu_nav_list_item, .menu_nav_rules_item, .menu_nav_btn_item');

  // 既にアニメーションが進行中の場合、それをキャンセルし、即時に最終状態へ
  if (tl) {
    tl.kill();
  }

  tl = gsap.timeline({
    repeat: 0,
    ease: "curtain",
  });

  // close animation
  tl
    .fromTo(closeBtn, {
      webkitClipPath: 'inset(0% 0% 0% 0%)',
      clipPath: 'inset(0% 0% 0% 0%)',
    }, {
      webkitClipPath: 'inset(0% 50% 0% 50%)',
      clipPath: 'inset(0% 50% 0% 50%)',
      duration: .8,
    }, "<")
    .add(function() {
      unlockScroll(); // スクロールのロックを解除
    }, "<")

    .add(function() {
      mainLists.forEach(navList => {
        // リストが複雑な場合はここで整理
        // const items = navList.querySelectorAll('.main_nav_list_item, .main_nav_child_item');
        gsap.fromTo(navList, {
          x: '0%',
          autoAlpha: 1,
          webkitClipPath: 'inset(0% 0% 0% 0%)',
          clipPath: 'inset(0% 0% 0% 0%)',
        }, {
          // x: '-30%',
          autoAlpha: 0.5,
          webkitClipPath: 'inset(0% 100% 0% 0%)',
          clipPath: 'inset(0% 100% 0% 0%)',
          duration: .5,
          stagger: {
            each: .05,
          },
        });
      });
    }, "<+=0")

    .to(menuBg, {
      x: '-100%',
      width: '0%',
      autoAlpha: .9,
      duration: .5,
    }, "<")

    .fromTo(openBtn, {
      webkitClipPath: 'inset(0% 50% 0% 50%)',
      clipPath: 'inset(0% 50% 0% 50%)',
    }, {
      webkitClipPath: 'inset(0% 0% 0% 0%)',
      clipPath: 'inset(0% 0% 0% 0%)',
      duration: .6,
    }, ">")

    .to(menu, {
      autoAlpha: 0,
    }, "<")

    .call(toggleClass, [openBtn, 'ing'], ">")
  ;
}



/* =============================================================
 * lockScroll
 * ========================================================== */
let scrollPosition = 0;

export function lockScroll(option = true) {
  if (!isMobile()) {
    // PC時の制御
    const smoother = ScrollSmoother.get(); // smootherインスタンスを取得
    scrollPosition = smoother.offset('.main'); // スクロール領域の位置を取得
    smoother.paused(true);
    smoother.scrollTo(scrollPosition); // 位置ずれを防ぐため取得した位置に強制スクロール
  } else {
    // SP時の制御
    if (option === true) {
      scrollPosition = window.scrollY;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.documentElement.classList.add('is-fixed'); // スクロール禁止
    } else {
      // document.documentElement.classList.add('is-fixed'); // スクロール禁止
    }
  }
}

export function unlockScroll(option = true) {
  if (!isMobile()) {
    // PC時の制御
    const smoother = ScrollSmoother.get(); // smootherインスタンスを取得
    smoother.paused(false);
  } else {
    // SP時の制御
    if (option === true) {
      document.documentElement.classList.remove('is-fixed'); // スクロール許可
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      window.scrollTo(0, scrollPosition);
    } else {
      // document.documentElement.classList.remove('is-fixed'); // スクロール許可
    }
  }
}
